import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import {
  COMPLETION_PROGRESS_MODE_NORMALIZED,
  COMPLETION_PROGRESS_MODE_FLAT,
  COMPLETION_PROGRESS_MODE_WEIGHTED,
} from "%/dynamic-component-editor/standard-components/base-story-card/completion-progress-percent";

// % modes: normalized (#40 per-subfolder equal weight, default), flat (immediate
// children only), weighted (#82 every subtree leaf counts equally).
export default class CompletionProgressMode extends BaseOption {
  static userInterfaceComponent = {
    label: "Percentage",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        { label: "Normalized", value: COMPLETION_PROGRESS_MODE_NORMALIZED },
        { label: "Flat", value: COMPLETION_PROGRESS_MODE_FLAT },
        { label: "Weighted", value: COMPLETION_PROGRESS_MODE_WEIGHTED },
      ],
    },
  };

  static defaultValue = COMPLETION_PROGRESS_MODE_NORMALIZED;
}
